// Router
import { replace } from "react-router-redux";
import { BASE_URL } from "../../config/constants";

export const navigateTo = (path) => (dispatch, getState) => {
  const {
    router: {
      location: { pathname }
    }
  } = getState();
  const correctPath = `${BASE_URL}${path}`;
  if (correctPath !== pathname) {
    dispatch(replace(correctPath));
  }
};
